import { Injectable } from '@angular/core';
import { SetInitialStateFacade } from '../../../../../common/models';
import { Store } from '@ngxs/store';
import {
  AllocationViewAvailableDocksInitialState,
  AllocationViewAvailableDocksLoad,
} from './allocation-view-available-docks.actions';
import { filter, take } from 'rxjs/operators';
import { HubBrief, HubContextFacade } from '../../../administration';
import { Observable } from 'rxjs';
import { AllocationViewAvailableDocksModel } from '../models';
import { AllocationViewAvailableDocksState } from './allocation-view-available-docks.state';

@Injectable({ providedIn: 'root' })
export class AllocationViewAvailableDocksFacade implements SetInitialStateFacade {
  items$: Observable<AllocationViewAvailableDocksModel> = this.store.select(AllocationViewAvailableDocksState.getItems);
  loaded$: Observable<boolean> = this.store.select(AllocationViewAvailableDocksState.getLoaded);

  constructor(private store: Store, private hubContextFacade: HubContextFacade) {}

  loadAll(): void {
    this.hubContextFacade.selectedHub$
      .pipe(filter(Boolean), take(1))
      .subscribe((hub: HubBrief) => this.store.dispatch(new AllocationViewAvailableDocksLoad(hub.id)));
  }

  setInitialState(): void {
    this.store.dispatch(new AllocationViewAvailableDocksInitialState());
  }
}
